import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { TransportManagementProfileDetails, TransportManagementProfileModel } from '../models';
import { TransportManagementProfileEndpoint } from '../constants/transport-management-profile-endpoint';

@Injectable({
  providedIn: 'root',
})
export class TransportManagementProfileItemBriefService {
  constructor(private http: WrapperHttpService) {}

  saveTransportManagementProfile(
    body: Partial<TransportManagementProfileDetails>,
  ): Observable<TransportManagementProfileDetails> {
    const url = `${API_URL}${TransportManagementProfileEndpoint.Base}${TransportManagementProfileEndpoint.Profiles}`;
    return this.http.withLoading().patch<TransportManagementProfileModel>(url, body);
  }

  cloneTransportManagementProfile(
    body: Partial<TransportManagementProfileDetails>,
  ): Observable<TransportManagementProfileDetails> {
    const url = `${API_URL}${TransportManagementProfileEndpoint.Base}${TransportManagementProfileEndpoint.Profiles}${TransportManagementProfileEndpoint.Clone}`;
    return this.http.withLoading().post<TransportManagementProfileDetails>(url, body);
  }

  deleteTransportManagementProfile(profileId: number): Observable<TransportManagementProfileModel> {
    const url = `${API_URL}${TransportManagementProfileEndpoint.Base}${TransportManagementProfileEndpoint.Profiles}/${profileId}`;
    return this.http.withLoading().delete<TransportManagementProfileModel>(url);
  }
}
